import { TranslationLocale } from '../../types/enums/translation/translation.enum'
import { Translation } from '../../types/models/translation/translation'

/**
 * The name of a translated record (formula, option, trip place, transport mean, characteristic)
 * in the given locale: its translation for that locale, else the French one (the base language,
 * always present), else ''. `locale` accepts a `TranslationLocale` or an app language ('fr', 'en').
 */
export function getTranslatedName(
  record: { translations?: Translation[] } | null | undefined,
  locale: TranslationLocale | string = TranslationLocale.FR
): string {
  const translations = record?.translations ?? []
  const localeEnum = locale.toUpperCase()
  return (
    translations.find((t) => String(t.locale) === localeEnum)?.value ||
    translations.find((t) => t.locale === TranslationLocale.FR)?.value ||
    ''
  )
}
